<template>
  <v-dialog :value="true" scrollable persistent :max-width="800">
    <v-card>
      <v-card-title class="primary modal-title pa-2" primary-title>
        Juntar Documentos
        <v-spacer/>
        <v-icon @click="fecharModal" color="white">close</v-icon>
      </v-card-title>
      <v-card-text class="pb-0" style="text-align: center">
        <div id="area-informacoes-card">
          <h2>Ordem dos documentos na junção</h2>
          <draggable v-model="documentos" :options="dragOptions" class="documentos-lista">
            <div v-for="(documento, idx) in documentos" :key="documento.id" class="documento-card">
              <span>{{idx+1}}. {{ documento.nome }}</span>
              <span v-show="documento.lote"> - {{documento.lote}} </span>
              <span v-show="documento.virtualizacao"> - {{documento.virtualizacao | az-date('DD/MM/YYYY')}}</span>
            </div>
          </draggable>
        </div>
        <strong>Arraste os cards para a posição desejada
          <v-tooltip v-if="apenasUmDocumento" bottom>
            <v-icon slot="activator" size="20" style="color: grey">info</v-icon>
            Não é possível alterar a ordem, apenas um documento foi selecionado.
          </v-tooltip>
        </strong>
        <v-divider class="my-2"/>
        <span v-if="apenasUmDocumento">Deseja juntar o documento exibido acima?</span>
        <span v-else>Deseja juntar os documentos na ordem definida acima?</span>
        <v-divider class="mt-2"/>
      </v-card-text>
      <v-card-actions class="justify-center mt-1">
        <v-btn class="botao-cancelar mx-2" color="#777" flat @click="fecharModal">
          Cancelar
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn class="botao-confirmar mx-2" flat @click="confirmar">
          Confirmar
        </v-btn>
      </v-card-actions>
  </v-card>
  </v-dialog>
</template>

<script>
import draggable from 'vuedraggable';

export default {
  name: 'OrdenarDocumentosJuntar',
  components: {
    draggable,
  },
  props:['documentosOrdenar'],
  data() {
    return {
      documentos: [],
      dragOptions: {
        animation: 150,
        handle: '.documento-card',
      },
    };
  },
  computed:{
    apenasUmDocumento(){
      return this.documentosOrdenar.length === 1
    }
  },
  mounted() {
    this.documentos = [...this.documentosOrdenar]
  },
  methods:{
    confirmar(){
      this.$emit('confirmar', this.documentos)
    },
    fecharModal(){
      this.$emit('fechar')
    }
  }
};
</script>

<style lang="stylus">
.documentos-lista
  padding-left 20px
  padding-right 20px
  max-width 800px

.documento-card
  text-align start
  background-color #f7f7f7
  border 1px solid #ddd
  padding 10px
  margin 5px 0
  cursor grab
  box-shadow 0 1px 2px rgb(0 0 0 / 0.2) !important

.botao-confirmar
  border 1px solid #0067a5
  background-color #0067a5 !important
  color #fff !important
  box-sizing border-box

.acoes
  padding 20px 0 !important

.v-input--selection-controls
  margin-top 0
  padding-top 0

.area-termos::-webkit-scrollbar
  width 12px
  border-radius 15px
  background-color #e5e5e5

.area-termos::-webkit-scrollbar-thumb
  border-radius 15px
  background-color #a2a2a2
</style>
